import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from './__root';
import { profileKeys } from '@/features/settings/queries';
import { ApiKeysPendingState } from '@/features/settings/api-keys/ApiKeysPendingState';
import { apiKeysSearchSchema } from '@/features/settings/api-keys/search-schema';
import { getProfile } from '@/lib/profile';
import { ACCESS } from '@/features/access/access';
import { requireRoleAccess } from '@/features/access/role-route-guard';

/**
 * `/api-keys` — split out of the old `/settings?section=api-keys` tab into
 * its own Organisation-group sidebar entry. `ApiKeysSection` itself moved
 * unchanged; only its page shell (`ApiKeysPage`) and this route are new.
 */
export const apiKeysRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/api-keys',
  beforeLoad: requireRoleAccess(ACCESS.apiKeys),
  // Eagerly imported (not inside the lazy component) so a deep link's
  // `?dialog=create` is validated before the route chunk loads — same shape
  // as `/billing` and `/settings`.
  validateSearch: apiKeysSearchSchema,
  loader: async ({ context: { queryClient } }) => {
    await queryClient
      .ensureQueryData({ queryKey: profileKeys.current(), queryFn: getProfile })
      .catch(() => undefined);
  },
  pendingComponent: ApiKeysPendingState,
  pendingMs: 0,
  pendingMinMs: 0,
  component: lazyRouteComponent(
    () => import('@/features/settings/api-keys/ApiKeysPage'),
    'ApiKeysPage',
  ),
});
